export default __webpack_public_path__ + "static/media/1989-thermal-img.246e248b.png";